import React, { useState } from 'react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { cachedNotesContext } from '../CachedNotes'
import { googleCalendarDataContext } from '../GoogleCalendar/persister'
import { DevtoolsContext, DevtoolsState, DevtoolsContextName } from './context'

type DevtoolsProviderProps = {
  children: React.ReactNode
}

export function DevtoolsProvider({ children }: DevtoolsProviderProps) {
  const [devtoolsState, setDevtoolsState] = useState<DevtoolsState>({
    activeContext: undefined,
  })

  const toggleDevtools = (context: DevtoolsContextName) => {
    setDevtoolsState((previous) => ({
      activeContext: previous.activeContext === context ? undefined : context,
    }))
  }

  // Only render devtools in development environment
  if (!import.meta.env.DEV) {
    return (
      <DevtoolsContext.Provider value={{ devtoolsState, toggleDevtools }}>
        {children}
      </DevtoolsContext.Provider>
    )
  }

  return (
    <DevtoolsContext.Provider value={{ devtoolsState, toggleDevtools }}>
      {children}

      {/* Default Query Context Devtools */}
      {devtoolsState.activeContext === 'defaultContext' && (
        <ReactQueryDevtools initialIsOpen={true} position='top-left' />
      )}

      {/* Cached Notes Context Devtools */}
      {devtoolsState.activeContext === 'cachedNotesContext' && (
        <ReactQueryDevtools
          initialIsOpen={true}
          context={cachedNotesContext}
          position='top-left'
        />
      )}

      {/* Google Calendar Data Context Devtools */}
      {devtoolsState.activeContext === 'googleCalendarDataContext' && (
        <ReactQueryDevtools
          initialIsOpen={true}
          context={googleCalendarDataContext}
          position='top-left'
        />
      )}
    </DevtoolsContext.Provider>
  )
}
